import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef, memo, } from 'react';
import { ESectionType, Section, StickySection } from 'Shared/components';
import styles from './GlobalFilters.css';
const GlobalFilters = forwardRef(({ hasShadow, children, className, withSticky, }, ref) => {
    if (withSticky) {
        return (_jsx(StickySection, Object.assign({ type: ESectionType.Minimized, hasShadow: hasShadow, className: className }, { children: _jsx("div", Object.assign({ ref: ref, className: styles.filtersLayout, "data-testid": "global-filters" }, { children: children }), void 0) }), void 0));
    }
    return (_jsx(Section, Object.assign({ type: ESectionType.Minimized, className: className }, { children: children }), void 0));
});
GlobalFilters.displayName = 'GlobalFilters';
export default memo(GlobalFilters);
